module.exports = __webpack_public_path__ + "static/media/close.58ff3c40.svg";